import React from "react";

function UserZoneTitle() {
  return (
    <div className="user-zone-title">
      <p>ESPACE ADHÉRENT RECETTE</p>
    </div>
  );
}

export default UserZoneTitle;
